














































import Vue from 'vue'
import { Route, RawLocation } from 'vue-router'
import Button from '@/components/shared/atoms/Button/Button'
import YLoginRegister from '@/components/Auth/YahooLoginButton/Register'

export default Vue.extend({
  components: {
    YLoginRegister,
    Button
  },
  props: {
    loginPath: {
      type: [String, Object as () => RawLocation],
      required: true
    },
    forwardedParams: {
      type: Object as () => Route['params'],
      required: true
    },
    forwardedQueries: {
      type: Object as () => Route['query'],
      required: true
    }
  }
})
